// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNumber(value: any) {
    if (typeof value === "string" && value.trim() === "") {
        return false;
    }
    return !isNaN(Number(value));
}

export function roundTo(value: number, decimalPlaces: number = 1): number {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
}
